<div class="warranty-sheet">
  <div class="warranty-sheet__handle"></div>

  <div class="warranty-sheet__content">
    @if (data.title) {
      <header class="warranty-sheet__header">
        <h2 class="warranty-sheet__title">{{ data.title }}</h2>
      </header>
    }

    <section class="warranty-sheet__body">
      @if (data.description) {
        @if (data.descriptionAsHtml) {
          <p
            class="warranty-sheet__description"
            [innerHTML]="data.description"
          ></p>
        } @else {
          <p class="warranty-sheet__description">{{ data.description }}</p>
        }
      }

      @if (data.requiresAcceptance) {
        <button
          type="button"
          class="warranty-sheet__acceptance"
          [class.warranty-sheet__acceptance--checked]="accepted()"
          (click)="toggleAccepted()"
        >
          <span class="warranty-sheet__checkbox" aria-hidden="true">
            @if (accepted()) {
              <span class="warranty-sheet__checkbox-dot"></span>
            }
          </span>

          <span class="warranty-sheet__acceptance-copy">
            <span>{{ data.acceptancePrefix }}</span>

            @if (data.acceptanceLinkLabel) {
              <a
                href="#"
                class="warranty-sheet__acceptance-link"
                (click)="openAcceptanceLink($event)"
              >
                {{ data.acceptanceLinkLabel }}
              </a>
            }

            <span>{{ data.acceptanceSuffix }}</span>
          </span>
        </button>
      }
    </section>

    <footer class="warranty-sheet__footer">
      @if (data.showCancel) {
        <button
          type="button"
          class="warranty-sheet__cancel"
          (click)="cancel()"
        >
          {{ data.cancelLabel || 'Cancel' }}
        </button>
      }

      <button
        type="button"
        class="warranty-sheet__confirm"
        [disabled]="!canConfirm()"
        (click)="confirm()"
      >
        {{ data.confirmLabel || 'Confirm' }}
      </button>
    </footer>
  </div>
</div>
